/*
 * Lunvelis World · lectura del catálogo publicado (solo lectura).
 * Los productos, los precios y la compra viven en lunvelis.world; aquí solo se consultan.
 * El resultado se guarda 15 minutos en sessionStorage para no repetir la consulta entre páginas.
 */
(() => {
  if (window.LunvelisWorld) return;
  const SOURCE = 'https://lunvelis.world';
  const KEY = 'lunvelis-world-catalog-v3';
  const TTL = 15 * 60 * 1000;
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

  const compact = (product) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const prices = variants.map((variant) => Number(variant.price)).filter(Number.isFinite);
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((tag) => tag.trim());
    const image = Array.isArray(product.images) && product.images[0] ? product.images[0].src : '';
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      vendor: product.vendor || '',
      type: product.product_type || '',
      min: prices.length ? Math.min(...prices) : null,
      max: prices.length ? Math.max(...prices) : null,
      variant: variants[0] ? variants[0].id : null,
      monthly: tags.includes('lunvelis:monthly'),
      quote: tags.includes('lunvelis:quote'),
      available: variants.length ? variants.some((variant) => variant.available !== false) : false,
      image
    };
  };

  const fetchAll = async () => {
    let all = [];
    for (let page = 1; page <= 6; page += 1) {
      const response = await fetch(`${SOURCE}/products.json?limit=250&page=${page}`, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      const list = Array.isArray(data.products) ? data.products : [];
      all = all.concat(list);
      if (list.length < 250) break;
    }
    return all.filter((product) => product.handle && String(product.vendor || '').startsWith('Lunvelis')).map(compact);
  };

  let pending = null;
  const load = () => {
    if (pending) return pending;
    pending = (async () => {
      try {
        const raw = sessionStorage.getItem(KEY);
        if (raw) {
          const cached = JSON.parse(raw);
          if (Date.now() - cached.t < TTL && Array.isArray(cached.p) && cached.p.length) return cached.p;
        }
      } catch (error) { /* sin caché: se consulta de nuevo */ }
      const list = await fetchAll();
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: list })); } catch (error) { /* almacenamiento no disponible */ }
      return list;
    })();
    pending.catch(() => { pending = null; });
    return pending;
  };

  const areaOf = (product) => String(product.vendor).replace(/^Lunvelis\s+/, '');
  const categoryOf = (product) => { const parts = String(product.type).split('·'); return (parts[1] || parts[0] || '').trim(); };
  const url = (product) => `${SOURCE}/products/${encodeURIComponent(product.handle)}`;
  const price = (product) => {
    if (product.min === null) return 'Consultar precio';
    return `${product.max !== null && product.max !== product.min ? 'Desde ' : ''}${money.format(product.min)}`;
  };

  window.LunvelisWorld = { source: SOURCE, load, money, areaOf, categoryOf, url, price };

  /* Cifras vivas para otras secciones: se ocultan si la consulta falla. */
  const metrics = document.querySelectorAll('[data-world-metric], [data-world-cats]');
  if (metrics.length) {
    load().then((list) => {
      document.querySelectorAll('[data-world-cats]').forEach((ul) => {
        const vendor = ul.dataset.worldCats;
        const counts = new Map();
        list.filter((product) => product.vendor === vendor).forEach((product) => { const name = categoryOf(product); counts.set(name, (counts.get(name) || 0) + 1); });
        if (!counts.size) return;
        ul.replaceChildren(...[...counts.entries()].sort((a, b) => b[1] - a[1]).map(([name, count]) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `/pages/partners-services?area=${encodeURIComponent(areaOf({ vendor }))}&cat=${encodeURIComponent(name)}#catalogo`;
          a.dataset.catalogJump = vendor;
          a.dataset.catalogCat = name;
          a.textContent = `${name} · ${count}`;
          li.append(a);
          return li;
        }));
        ul.hidden = false;
      });
      metrics.forEach((element) => {
        if (!element.dataset.worldMetric) return;
        const count = list.filter((product) => product.vendor === element.dataset.worldMetric).length;
        if (!count) return;
        element.textContent = `${count} ${count === 1 ? 'servicio publicado' : 'servicios publicados'} en Lunvelis World`;
        element.hidden = false;
      });
    }).catch(() => { /* sin cifra: el bloque sigue siendo útil */ });
  }
})();
